import imageCompression                from "browser-image-compression";
import { useEffect, useRef, useState } from "react";

import { useGetProfileId, useSetLoggedIn, useSetProfileData }                                                        from "_common/hooks/auth";
import { useGetAppLocale, useGetOpenUserOnboardingModal, useSetOpenUserOnboardingModal, useSetOpenUserSettingModal } from "_common/hooks/global";
import Toast                                                                                                         from "_common/toast";
import { processUploadedImageFile }                                                                                  from "_common/utils/profile";
import { setFavoriteGames }                                                                                          from "_services/api/broadcast";
import { updateUserProfile, uploadImage }                                                                            from "_services/api/user";

import { _getUserProfile } from "./fetcher";
import Presentation        from "./presentation";

const component = props => {
	const {
		editUserProfile,
		toggleEditUserProfile
	} = props;

	const genderOptions = [
		{ label: "Male", value: "Male" },
		{ label: "Female", value: "Female" },
		{ label: "Others", value: "Other" }
	];

	const hiddenFileInput           = useRef ( null );
	const setUserProfile            = useSetProfileData ();
	const setIsLoggedIn             = useSetLoggedIn ();
	const toggleUserSettingsPopup   = useSetOpenUserSettingModal ();
	const toggleUserOnboardingPopup = useSetOpenUserOnboardingModal ();

	const [ userProfileDetails, setUserProfileDetails ] = useState ( {} );
	const [ validInstagram, setValidInstagram ]         = useState ( true );
	const [ open, setOpen ]                             = useState ( false );
	const [ validYoutube, setValidYoutube ]             = useState ( true );
	const [ validDiscord, setValidDiscord ]             = useState ( true );

	/* const [ contentLocale, setContentLocale ]                     = useState ( userProfile?.contentLocale ); */
	const [ followingGames, setFollowingGames ]                   = useState ( null );
	const [ gamesSelectedActive, setGamesSelectedActive ]         = useState ( false );
	const [ languagesSelectedActive, setLanguagesSelectedActive ] = useState ( false );
	const [ onboardModalStep, setOnBoardModalStep ]               = useState ( 0 );
	const [ allGames, setAllGames ]                               = useState ( [] );
	const [ rawImageData, setRawImageData ]                       = useState ( null );
	const appLocale                                               = useGetAppLocale ();
	const [ uploadedProfileImage, setUploadedProfileImage ]       = useState ( null );
	const myUserId                                                = useGetProfileId ();
	const onboard                                                 = useGetOpenUserOnboardingModal ();

	const getProfile = async userId => {
		try {
			const response = await _getUserProfile ( { userId } );

			setUserProfileDetails ( {
				...response,
				name           : response?.name?.trim (),
				photo          : response?.photo,
				city           : response?.city,
				mobile         : response?.mobile,
				shortBio       : response?.shortBio,
				gender         : response?.gender,
				instagram      : ( response?.instagram ) && ( "https://www.instagram.com/" + response.instagram ),
				youtube        : response?.youtube,
				discord        : response?.discord,
				followingGames : response?.followingGames
			} );
			setFollowingGames ( response?.followingGames );

		} catch ( err ) {
			// Show error here
		}
	};

	useEffect ( () => {
		getProfile ( myUserId );
	}, [ myUserId ] );

	useEffect ( () => {
		if ( onboard === false ) {
			setGamesSelectedActive ( false );
			setLanguagesSelectedActive ( false );
		}
	}, [ onboard ] );

	const [ isLoading, setIsLoading ] = useState ( false );

	const getSelectedOption = value => {
		switch ( value ) {
			case "Male":
				return genderOptions[0];

			case "Female":
				return genderOptions[1];

			case "Other":
				return genderOptions[2];

			default:
				return null;
		}
	};

	const setGender = value => {
		setUserProfileDetails ( {
			...userProfileDetails,
			gender: value
		} );
	};

	const handleGamesClick = () => {
		setOnBoardModalStep ( 3 );
		setGamesSelectedActive ( true );
		toggleUserOnboardingPopup ( true );

	};

	const handleLanguageClick = () => {
		setOnBoardModalStep ( 2 );
		setLanguagesSelectedActive ( true );
		toggleUserOnboardingPopup ( true );
	};

	const handleInputChange = ( e, type ) => {
		let value = e.target.value.trim ();

		switch ( type ) {

			case "instagram":
				validateInstagram ( value );
				setUserProfileDetails ( {
					...userProfileDetails,
					instagram: value
				} );
				break;

			case "youtube":
				validateYoutube ( value );
				setUserProfileDetails ( {
					...userProfileDetails,
					youtube: value
				} );
				break;

			case "discord":
				validateDiscord ( value );

				setUserProfileDetails ( {
					...userProfileDetails,
					discord: value
				} );
				break;

			default:
				setUserProfileDetails ( {
					...userProfileDetails,
					[type]: e.target.value
				} );
				break;
		}

	};

	const validateInstagram = value => {
		var re = new RegExp ( "https?://(www.)?instagram.com/[A-Za-z0-9._]{1,30}/?" );

		if ( value != null && value != "" )
			setValidInstagram ( re.test ( value ) );
		else setValidInstagram ( true );
	};

	const validateDiscord = value => {
		if ( value != null && value != "" )
			setValidDiscord ( value.includes ( "discord.gg" ) );
		else setValidDiscord ( true );
	};
	const validateYoutube = value => {
		if ( value != null && value != "" )
			setValidYoutube ( value.startsWith ( "https://www.youtube.com" ) || value.startsWith ( "https://youtube.com" ) );
		else setValidYoutube ( true );
	};

	const updateUserDetails = async () => {
		let language = "";
		let gameIds  = [];

		if ( userProfileDetails.contentLocale.length !== 2 ) {
			switch ( userProfileDetails.contentLocale ) {
				case "English": {
					language = "en";
					break;
				}

				case "Malyalam": {
					language = "ml";
					break;
				}

				case "Hindi": {
					language = "hi";
					break;
				}

				case "Tamil": {
					language = "ta";
					break;
				}

				case "Telugu": {
					language = "te";
					break;
				}

				case "Kannada": {
					language = "kn";
					break;
				}

				default:
					break;

			}
			userProfileDetails.contentLocale = language;
		}
		if ( typeof followingGames[0] === "object" ) {
			gameIds = followingGames.map ( game => game.id );

		} else {
			gameIds = followingGames;
		}
		// userProfileDetails.followingGames = followingGames;
		if ( uploadedProfileImage ) {
			userProfileDetails.photo = uploadedProfileImage;
		}
		const apiData = {
			sportsFanId: myUserId,
			appLocale,
			userProfileDetails
		};

		if ( validDiscord && validInstagram && validYoutube ) {
			setIsLoading ( true );
			// await updateUserProfile ( apiData );
			try {
				await Promise.all ( [ setFavoriteGames ( gameIds ), updateUserProfile ( apiData ) ] );
			} catch ( err ) {
				Toast.error ( "Something went wrong" );
			}
			// setFavoriteGames
			setUserProfile ( userProfileDetails );
			setIsLoggedIn ( true );

			window.location.reload ();
			toggleUserSettingsPopup ( false );
		}

	};

	const updateContentLocale = value => {
		/* setContentLocale ( value ); */
		setUserProfileDetails (
			{
				...userProfileDetails,
				contentLocale: value
			}
		);
	};

	const updateFollowingGames = ( games, allGames ) => {
		setAllGames ( allGames );
		setFollowingGames ( games );
	};

	useEffect ( () => {

		if ( allGames.length > 0 ) {

			let followingGamesObjects = allGames.filter ( game => {
				return followingGames.includes ( game.id );
			} );

			setUserProfileDetails (
				{
					...userProfileDetails,
					followingGames: followingGamesObjects
				}
			);
		}

	}, [ allGames ] );

	const handleImageUpload = async payload => {
		const fileExtension = "jpeg";
		const formData      = new FormData ();
		const currentTime   = Math.floor ( Date.now () / 1000 );
		const fileName      = `incoming/${ process.env.APP_ENV }-${ userProfileDetails.id }-${ currentTime }.${ fileExtension }`;
		const options       = {
			maxSizeMB        : 1,
			maxWidthOrHeight : 720,
			useWebWorker     : true,
			fileType         : `image/${ fileExtension }`
		};

		try {
			const compressedFile = await imageCompression ( payload.blobFile, options );

			formData.append ( "file", compressedFile );
			formData.append ( "fileName", fileName );
			formData.append ( "bucket", "rooter-profile-images" );

			const res = await uploadImage ( { formData } );

			setUploadedProfileImage ( res.url );
			setOpen ( false );

		} catch ( error ) {
			Toast.error ( "Something went wrong!", "Please try again later" );
		}
	};

	const onImageDrop = async files => {
		if ( !files?.length )
			return;

		try {
			const __file  = files[0];
			const maxSize = 52428800; // 50 MB

			if ( __file.size > maxSize ) { // 50MB
				Toast.error ( `File size should be less than ${ Math.round ( maxSize / 1048576 ) } MB` );

				return;
			}

			const imageObj = await processUploadedImageFile ( __file );

			const imageObject = {
				imageData   : imageObj.preview,
				imageType   : imageObj.type,
				imageHeight : imageObj.height,
				imageWidth  : imageObj.width
			};

			setRawImageData ( imageObject );
			setOpen ( true );
		} catch ( error ) {
			Toast.error ( error );
		}
	};

	return (
		<Presentation
			editUserProfile         = { editUserProfile }
			gamesSelectedActive     = { gamesSelectedActive }
			genderOptions           = { genderOptions }
			getSelectedOption       = { getSelectedOption }
			handleGamesClick        = { handleGamesClick }
			handleImageUpload       = { handleImageUpload }
			handleInputChange       = { handleInputChange }
			handleLanguageClick     = { handleLanguageClick }
			hiddenFileInput         = { hiddenFileInput }
			isLoading               = { isLoading }
			languagesSelectedActive = { languagesSelectedActive }
			onboard                 = { onboard }
			onboardModalStep        = { onboardModalStep }
			onImageDrop             = { onImageDrop }
			open                    = { open }
			rawImageData            = { rawImageData }
			setGender               = { setGender }
			setOpen                 = { setOpen }
			setRawImageData         = { setRawImageData }
			toggleEditUserProfile   = { toggleEditUserProfile }
			updateContentLocale     = { updateContentLocale }
			updateFollowingGames    = { updateFollowingGames }
			updateUserDetails       = { updateUserDetails }
			uploadedProfileImage    = { uploadedProfileImage }
			userProfileDetails      = { userProfileDetails }
			validDiscord            = { validDiscord }
			validInstagram          = { validInstagram }
			validYoutube            = { validYoutube }
		/>
	);
};

export default component;
